// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonArrowSmall_button__2XTJN","arrow":"ButtonArrowSmall_arrow__LZ3uj"};